module Shared.Dto.SensorGraphData

open System
open Shared.DtoTypes.LeafletWetness

type GraphAirDataDto = {
    TimeStamp: DateTimeOffset
    AirTemperature: float
    AirHumidity: float
    HumidTemperature: float
    DewPoint: float
    LeafletWetness: LeafletWetness
    IsForecast: bool
}

type GraphSoilDataNodeDto = {
    TimeStamp: DateTimeOffset
    SoilTemperature: float
    SoilHumidity: float
    SoilConductivity: float
}

type GraphFourTimesSoilDataDto = {
    TimeStamp: DateTimeOffset
    SoilTemperature1: float
    SoilMoisture1: float
    SoilConductivity1: float

    SoilTemperature2: float option
    SoilMoisture2: float option
    SoilConductivity2: float option

    SoilTemperature3: float option
    SoilMoisture3: float option
    SoilConductivity3: float option

    SoilTemperature4: float option
    SoilMoisture4: float option
    SoilConductivity4: float option
}

type GraphSoilDataDto = {
    WetLimit: float option
    DryLimit: float option
    Nodes: GraphSoilDataNodeDto list
}

type GraphRainFallDataDto = {
    TimeStamp: DateTimeOffset
    CurrentRainFall: float
    RainFallSum: float
    IsForecast: bool
}

type GraphLeafletMoistureDataDto = {
    TimeStamp: DateTimeOffset
    LeafletMoisture: float
    LeafletTemperature: float
}

type GraphSoilPhDataDto = {
    TimeStamp: DateTimeOffset
    SoilPh: float
    SoilTemperature: float
}

type GraphAverageWindSpeedDataDto = {
    TimeStamp: DateTimeOffset
    AverageWindSpeed: float
}

type GraphWeatherStationDataDto = {
    TimeStamp: DateTimeOffset
    AirTemperature: float
    AirHumidity: float
    HumidTemperature: float
    DewPoint: float
    LeafletWetness: LeafletWetness
    MaxWindSpeed: float
    AverageWindSpeed: float
    IsForecast: bool
}

type GraphLiquidLevelDataDto = {
    TimeStamp: DateTimeOffset
    LiquidLevel: int
}

type GraphSolarRadiationDataDto = {
    TimeStamp: DateTimeOffset
    SolarRadiation: float
}

type GraphDistanceDataDto = {
    TimeStamp: DateTimeOffset
    Distance: int
}

type GraphPressureDataDto = {
    TimeStamp: DateTimeOffset
    Pressure: float
}

type GraphWaterQualityDataDto = {
    TimeStamp: DateTimeOffset

    Turbidity: float option
    DissolvedOxygen: float option
    OxidationReductionPotential: int option
    EC: int option
    PH: float option
}

type GraphDataDto =
    | Air of GraphAirDataDto list
    | Soil of GraphSoilDataDto
    | RainFall of GraphRainFallDataDto list
    | LeafletMoisture of GraphLeafletMoistureDataDto list
    | SoilPh of GraphSoilPhDataDto list
    | AverageWindSpeed of GraphAverageWindSpeedDataDto list
    | WeatherStation of GraphWeatherStationDataDto list
    | LiquidLevel of GraphLiquidLevelDataDto list
    | SolarRadiation of GraphSolarRadiationDataDto list
    | FourTimesSoil of GraphFourTimesSoilDataDto list
    | Pressure of GraphPressureDataDto list
    | Distance of GraphDistanceDataDto list
    | WaterQuality of GraphWaterQualityDataDto list

let isGraphDataEmpty (data: GraphDataDto) : bool =
    match data with
    | Air list -> List.isEmpty list
    | RainFall list -> List.isEmpty list
    | LeafletMoisture list -> List.isEmpty list
    | SoilPh list -> List.isEmpty list
    | AverageWindSpeed list -> List.isEmpty list
    | WeatherStation list -> List.isEmpty list
    | Soil soilData -> List.isEmpty soilData.Nodes
    | LiquidLevel list -> List.isEmpty list
    | SolarRadiation list -> List.isEmpty list
    | FourTimesSoil list -> List.isEmpty list
    | Pressure list -> List.isEmpty list
    | Distance list -> List.isEmpty list
    | WaterQuality list -> List.isEmpty list